import React from "react";
import autoBind from 'react-autobind';
import { Navbar, NavbarNav, NavItem, NavLink, NavbarToggler, Collapse } from "mdbreact";
import CISIcon from '../../CISIcon';
import './TopNavBar.css';
export default class TopNavBar extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);    
    this.state = {
      collapseID: ""
    };
  }

  toggleCollapse = (collapseID) => () =>
      this.setState(prevState => ({
        collapseID: prevState.collapseID !== collapseID ? collapseID : ""
  }));

  render() {       
    return (
        <Navbar dark expand="md" fixed="top" >
       <NavbarToggler
              onClick={this.toggleCollapse("navbarCollapse1")}
          />
          <Collapse id="navbarCollapse1" isOpen={this.state.collapseID} navbar>
            <NavbarNav left>
              <NavItem>
                  <NavLink to="/">
                    <CISIcon name="home" className="web-link-logo" />
                  </NavLink>
              </NavItem>    
            </NavbarNav>
            </Collapse>
        </Navbar>
    );
  }
}